
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "undefined";
              window.beaePageSetting.pageTitle = "Scrolling Bar"; 
              window.beaePageSetting.pageType = "section";

          let js_9096RHBJ = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-8vlzff2wsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8vlzff2w',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8vlzff2w');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8vlzff2w: ', ex)
      };
    

      try {
        let argid = 'beae-jo1z5y7t',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jo1z5y7t',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jo1z5y7t');
        args.el = args.els[0];
        ((y) => { var C;if(((C=y==null?void 0:y.mode)==null?void 0:C.value)=="builder"&&!(y!=null&&y.disabled))return;let S=y.el.querySelector(".beae-marquee-content"),B=S.parentNode,w=_=>{y.el.querySelectorAll(".beae-marquee-content-clone").forEach(L=>L.parentNode.removeChild(L));let M=0,V=Math.ceil((B.offsetWidth>=y.el.offsetWidth?B.offsetWidth:y.el.offsetWidth)*2/_.offsetWidth);V=V<=10?V:10;for(let L=0;L<V;L++){let T=_.cloneNode(!0);T.classList.add("beae-marquee-content-clone");const N=T.querySelectorAll("img");N.length>0&&N.forEach(E=>{E.setAttribute("loading","lazy"),E.setAttribute("load","true")}),B.appendChild(T),M<y.el.offsetWidth&&(M+=_.offsetWidth)}B.style.setProperty("--marquee-animation-duration",M/10*.01*((y==null?void 0:y.speed)??10)+"s"),B.style.setProperty("--marquee-animation-offset",-M+"px"),window.dispatchEvent(new CustomEvent("marqueeClone",{detail:{id:y==null?void 0:y.id}}))};window.addEventListener("resize",()=>{w(S)}),w(S);let $=new IntersectionObserver(_=>{_.forEach(M=>{M.intersectionRatio>0&&(w(S),M.target.querySelectorAll('[loading="lazy"]').forEach(V=>{V.removeAttribute("loading")}),$.unobserve(M.target))})},{});$.observe(B) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jo1z5y7t: ', ex)
      };
    

      try {
        let argid = 'beae-h1458gdsblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h1458gds',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h1458gds');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h1458gds: ', ex)
      };
    

      try {
        let argid = 'beae-h1458gdsblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h1458gds',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h1458gds');
        args.el = args.els[1];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h1458gds: ', ex)
      };
    

      try {
        let argid = 'beae-h1458gdsblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h1458gds',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h1458gds');
        args.el = args.els[2];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h1458gds: ', ex)
      };
    

      try {
        let argid = 'beae-h1458gdsblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h1458gds',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h1458gds');
        args.el = args.els[3];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h1458gds: ', ex)
      };
    }; if (window.BEAEBASE) {js_9096RHBJ()} else {window.BEAEPAGEJS.push(js_9096RHBJ)} })(); 